export default __webpack_public_path__ + "static/media/gallery_01.32587ed6.jpg";